import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/ai/requests/{requestId}']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getAIRequestById = async ({ requestId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/ai/requests/{requestId}', { requestId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getAIRequestById;